import { nextTick } from 'vue';
import { Route } from 'vue-router';

const clearIfNew = async (to: Route): Promise<boolean> => new Promise<boolean>((resolve) => {
  const ctx = to.meta?.ctx;
  const isNew = ['1', 1, 'true', true].includes(to.query?.new as string);

  if (!isNew) {
    resolve(false);
    return;
  }

  nextTick(() => {
    sessionStorage.removeItem(`${ctx}.orderUuid`);
    sessionStorage.removeItem(`${ctx}.referrer`);
    sessionStorage.removeItem(`${ctx}.formData`);
    sessionStorage.removeItem(`${ctx}.selectedTariffs`);
    sessionStorage.removeItem(`${ctx}.customFields`);
    sessionStorage.removeItem(`${ctx}.customFieldRequiredBySource`);
    sessionStorage.removeItem(`${ctx}.canContinueAsLead`);
    sessionStorage.removeItem(`${ctx}.calculatorFormData`);
    sessionStorage.removeItem(`${ctx}.existingCustomerData`);
    sessionStorage.removeItem(`${ctx}.calculatorSelectedTariffs`);
    sessionStorage.removeItem(`${ctx}.calculatorStreets`);
    sessionStorage.removeItem(`${ctx}.categories`);
    sessionStorage.removeItem(`${ctx}.accessibleSteps`);
    sessionStorage.removeItem(`${ctx}.calculatorPostcodeStreetsRequired`);
    sessionStorage.removeItem(`${ctx}.internetBestandskunde`);
    sessionStorage.removeItem(`${ctx}.orderMode`);
    sessionStorage.removeItem(`${ctx}.currentContractTariff`);
    sessionStorage.removeItem(`${ctx}.initialPrefilledFields`);
    sessionStorage.removeItem(`${ctx}.relocationAddress`);
    sessionStorage.removeItem(`${ctx}.relocationPriceData`);
    sessionStorage.removeItem(`${ctx}.preparedDataAddress`);
    sessionStorage.removeItem(`${ctx}.contractData`);
    sessionStorage.removeItem(`${ctx}.ordersCreate.calculatorSelectedBonuses`);
    sessionStorage.removeItem(`${ctx}.ordersCreate.calculatorUpdatedPrices`);
    sessionStorage.removeItem(`${ctx}.calculatorTransitionTariffs`);
    sessionStorage.removeItem(`${ctx}.isDynamicPower`);
    sessionStorage.removeItem(`${ctx}.overviewInputFlags`);

    localStorage.removeItem('customerNumber');

    resolve(true);
  });
});

export default clearIfNew;
